import React from 'react';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import Switch from '@material-ui/core/Switch';
import { useDispatch, useSelector } from 'react-redux';

import { addAlert } from 'store/actions/alert/alerts';
import { authPatchRequestWithParam } from 'helpers/apiRequests';
import { formStyles } from 'consts/styles/Form';
import { fromUpperCaseToUnderScore } from 'helpers/variablesNamesFit';

const PermissionEdit = props => {
  const { user } = props;
  const [switchIsActiveChecked, setSwitchIsActiveChecked] = React.useState(
    !user.isActive_
  );
  const [
    switchPhoneVerifyChecked,
    setSwitchPhoneVerifyChecked,
  ] = React.useState(!!user.phoneVerify);
  const [
    switchEmailVerifyChecked,
    setSwtichEmailVerifyChecked,
  ] = React.useState(!!user.emailVerify);
  const dispatch = useDispatch();

  const useString = () => {
    const language = useSelector(state => state.language);
    return language;
  };
  const [strings] = React.useState(useString().adminZone.permissions);
  const alertSubtitles = useString().alerts;

  const formClasses = formStyles();

  const savePermission = (endPoint, payload) => {
    authPatchRequestWithParam(endPoint, user.uid, payload).then(result => {
      if (result.status === 200)
        dispatch(
          addAlert({
            title: alertSubtitles.addDataSuccess.title_,
            desc: alertSubtitles.addDataSuccess.desc_,
            type: 'success',
          })
        );
      else
        dispatch(
          addAlert({
            title: alertSubtitles[result.data.code].title_,
            desc: alertSubtitles[result.data.code].desc_,
            type: 'error',
          })
        );
    });
  };

  const handleSwitchIsActiveChange = () => {
    const payload = { isActive: !!switchIsActiveChecked };
    savePermission('editUserByAdmin', fromUpperCaseToUnderScore(payload));
    setSwitchIsActiveChecked(!switchIsActiveChecked);
  };

  const handleSwitchVerifyPhone = () => {
    const payload = { phoneVerify: !switchPhoneVerifyChecked };
    savePermission('editUserByAdmin', fromUpperCaseToUnderScore(payload));
    setSwitchPhoneVerifyChecked(!switchPhoneVerifyChecked);
  };

  const handleSwitchVerifyEmail = () => {
    const payload = { emailVerify: !switchEmailVerifyChecked };
    savePermission('editUserByAdmin', fromUpperCaseToUnderScore(payload));
    setSwtichEmailVerifyChecked(!switchEmailVerifyChecked);
  };

  return (
    <div>
      <Container component="main">
        <div
          className={`${formClasses.Form}--flex ${formClasses.Form}--flex--between ${formClasses.Form}--flex--direction`}
        >
          <Grid container spacing={2}>
            <Grid className={`${formClasses.Form}--flex`} item s={12} sm={8}>
              <span className={`${formClasses.Form}__label`}>
                {strings.manageUserPermission.active_}
              </span>
            </Grid>
            <Grid item s={12} sm={4}>
              <Switch
                color="primary"
                checked={switchIsActiveChecked}
                onChange={handleSwitchIsActiveChange}
                name="user"
                classes={{
                  checked: `${formClasses.Form}__switch`,
                  track: `${formClasses.Form}__switch__track`,
                }}
              />
            </Grid>
            <Grid className={`${formClasses.Form}--flex`} item s={12} sm={8}>
              <span className={`${formClasses.Form}__label`}>
                {strings.manageUserPermission.email_}
              </span>
            </Grid>
            <Grid item s={12} sm={4}>
              <Switch
                color="primary"
                checked={switchEmailVerifyChecked}
                onChange={handleSwitchVerifyEmail}
                name="email"
                inputProps={{ 'aria-label': 'test' }}
                classes={{
                  checked: `${formClasses.Form}__switch`,
                  track: `${formClasses.Form}__switch__track`,
                }}
              />
            </Grid>
            <Grid className={`${formClasses.Form}--flex`} item s={12} sm={8}>
              <span className={`${formClasses.Form}__label`}>
                {strings.manageUserPermission.phone_}
              </span>
            </Grid>
            <Grid item s={12} sm={4}>
              <Switch
                color="primary"
                checked={switchPhoneVerifyChecked}
                onChange={handleSwitchVerifyPhone}
                name="phone"
                inputProps={{ 'aria-label': 'test' }}
                classes={{
                  checked: `${formClasses.Form}__switch`,
                  track: `${formClasses.Form}__switch__track`,
                }}
              />
            </Grid>
          </Grid>
        </div>
      </Container>
    </div>
  );
};

PermissionEdit.propTypes = {
  user: PropTypes.object.isRequired,
};

export default PermissionEdit;
